var map = {
	"./allSuggested1.webp": 6702,
	"./allSuggested2.webp": 6303,
	"./allSuggested3.webp": 8060,
	"./allSuggested4.webp": 429,
	"./allSuggested5.webp": 4866,
	"./allSuggested6.webp": 9763,
	"./allSuggested7.webp": 6720,
	"./allSuggested8.webp": 6561,
	"./allSuggested9.webp": 6806,
	"./roundedShape.webp": 9159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9005;